import { projectRequest } from 'api';
import getUserInfo from 'api/user/getUserInfo';
import { IAccountCheckResponse } from './types';

/**
 * GET /announcements/check - Check main account status and confirmation requirements
 * Enriched with supplier email from getUserInfo API
 * 
 * @returns Account status information for popup flow decision with supplier email
 */
export const getAccountCheck = async (): Promise<IAccountCheckResponse & { supplier_email: string }> => {
  try {
    const response = await projectRequest(false, 'v2').get<IAccountCheckResponse>('/announcements/check');
    const accountData = response.data;
    
    // Get supplier email using getUserInfo API
    let supplier_email = '';
    if (accountData.supplier_id && accountData.supplier_user_id) {
      try {
        const userInfoResponse = await getUserInfo({
          supplier_id: String(accountData.supplier_id),
          ids: [accountData.supplier_user_id],
        });
        supplier_email = userInfoResponse.data[accountData.supplier_user_id]?.email || '';
      } catch (emailError) {
        console.warn('Failed to fetch supplier email:', emailError);
        // Continue without email rather than failing the entire request
      }
    }
    
    return {
      ...accountData,
      supplier_email,
    };
  } catch (error) {
    console.error('Failed to check account status:', error);
    throw error;
  }
};
